import { Outlet, useNavigate } from "react-router-dom";
import { SideNav } from "../components";

import { userService } from "../service";
import { useContext, useEffect, useRef, useState } from "react";
import { loaderContext } from "../context/context";

function MainLayout() {
  const popupref = useRef();
  const navigate = useNavigate();

  const { showLoader, hideLoader } = useContext(loaderContext);
  const [bottomListner, setBottomListner] = useState();
  const [isPopUp, setPopup] = useState(false);

  const handleLogout = () => {
    showLoader();
    sessionStorage.removeItem("userDetail");
    navigate(0);
  };

  const setBottomListnerValue = (value) => {
    setBottomListner(value);
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleOutsideClick(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setPopup(false);
        }
      }

      document.addEventListener("click", handleOutsideClick);
      return () => document.removeEventListener("click", handleOutsideClick);
    }, [ref]);
  }

  useOutsideAlerter(popupref);

  return (
    <div className="page-wrapper flex-nowrap">
      <div className="fc-auto">
        <SideNav />
      </div>
      <div className="flex flex-col wrapper overflow-x-hidden">
        <div className="container pos-sticky top-0 bg-glassy z-index-lg">
          <div className="list-item justify-content-end">
            <div
              className="pop-up-wrapper"
              ref={popupref}
              id="profile-popup"
              onClick={() => setPopup(!isPopUp)}
            >
              <div className="avatar avatar--sm f-600">
                {userService.getUserNameIcon}
              </div>
              {isPopUp && (
                <div className="pop-up-content">
                  <div
                    className="list-item  mini-text"
                    onClick={() => navigate("/profile")}
                  >
                    <div className="cursor-pointer">
                      <p
                        className="text-ellipsis sub-2 text-capitalize"
                        title={userService?.userData?.name}
                      >
                        {userService?.userData?.name}
                      </p>
                      <p
                        className="text-ellipsis text-700"
                        title={userService?.userData?.email}
                      >
                        {userService?.userData?.email}
                      </p>
                    </div>
                  </div>
                  <div className="border-top-dashed">
                    <div
                      className="list-item f-500 text-danger mini-text gap-xs cursor-pointer"
                      onClick={() => handleLogout()}
                    >
                      <div className="list-icon">
                        <span className="material-symbols-rounded icon--xs">
                          logout
                        </span>
                      </div>
                      <div className="lis-item">
                        <p>Logout</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="flex-expand p-3 pb-5 overflow-y-auto"
          ref={bottomListner}
        >
          <Outlet context={{ setBottomListnerValue }} />
        </div>
      </div>
    </div>
  );
}

export default MainLayout;
